import styled from '@emotion/styled';
import H1 from '@base/H1/H1';
import Typography from 'aquilla/core/atoms/Typography';
import Paper from '@base/Paper/Paper';
import { Fonts, mediaQuery, Spacings } from '@styles/index';

const Wrapper = styled(Paper)`
  grid-column: span 18;
  margin-bottom: ${Spacings.SPACING_6B};
  padding-bottom: ${Spacings.SPACING_8B};
  padding-top: ${Spacings.SPACING_8B};
  ${mediaQuery.uptoMobile} {
    background: transparent;
    box-shadow: none;
    padding: ${Spacings.SPACING_6B} 0 0;
  }
`;

const Title = styled(H1)`
  font-size: ${Fonts.H2};
  line-height: ${Fonts.PARA_LINE_HEIGHT};
`;

const Description = styled(Typography)`
  color: var(--color-text-secondary);
  margin-top: ${Spacings.SPACING_2B};
`;

const TopBar = ({ breadcrumbs, title, description }) => {
  return (
    <Wrapper>
      {breadcrumbs}
      <Title color="var(--color-text-primary)">{title}</Title>
      {description && <Description variant="p2">{description}</Description>}
    </Wrapper>
  );
};

export default TopBar;
